// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-sidebar {
  min-width: 350px;
  max-width: 360px;
  min-height: 70vh;
  background-color: #ffffff;
  color: #000;
  overflow: auto !important;
  transition: width 0.2s ease;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 10;
  border-right: 1px solid #e4e6f1;
  padding: 10px 6px 10px 6px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.sidebar-create {
  margin-bottom: 0px;
}
.sidebar-create .btn {
  font-size: 14px;
  font-weight: 500;
  border: none;
  background-color: #0d99ff;
  border-radius: 12px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.custom-dropdown {
  background-color: #ffffff;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  margin-top: 5px;
  position: absolute;
  min-width: 300px;
  z-index: 999;
  border: 1px solid #e4e6f1;
  overflow: hidden;
}

.custom-dropdown .dropdown-item {
  padding: 10px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.custom-dropdown .dropdown-item:hover {
  background-color: #f1f3f5;
  color: #000;
}

.sidebar-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
}
.sidebar-controls h6 {
  font-size: 15px;
  font-weight: 600;
  margin: 0;
}
.sidebar-controls .form-control {
  background-color: #f2f4f8;
  border: 1px solid #ccc;
  color: #000;
  font-size: 13px;
  height: 30px;
}
.sidebar-controls .btn {
  font-size: 13px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #ccc;
  color: #333;
  background-color: #fff;
}

.sidebar-tabs .btn-group .btn {
  font-size: 13px;
  border-radius: 6px !important;
  background-color: #f0f0f0;
  color: #000;
  border: none;
  font-weight: 500;
}

.sidebar-tabs .btn-group .btn.active {
  background-color: #1E1E1E;
  color: #fff;
  font-weight: bold;
}

.sidebar-list {
  overflow-y: auto;
  flex-grow: 1;
  padding-bottom: 10px;
}

.sidebar-list > div {
  background: #fff;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
  margin-bottom: 10px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.sidebar-list > div:hover {
  background-color: #f0f0f5;
}

.search-input {
  font-size: 17px;
  max-width: 200px;
  margin-left: 4px;
  border-radius: 3px;
  color: black;
  border: 1px solid lightgrey;
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
  box-shadow: none;
}

.resizer {
  width: 5px;
  cursor: col-resize;
  background-color: #f1f1f1;
  height: 100vh;
  position: relative;
  z-index: 9;
}

.bordered-section {
  margin-top: 7px;
  margin-left: 6px;
  margin-right: 5px;
  margin-bottom: 10px;
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgrey;
}

.createnewbtn {
  background-color: #077fd5;
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 12px;
  height: 42px;
  color: white;
  min-width: 300px;
}

.createnewbtn:hover {
  background-color: #0C8CE9;
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 12px;
  height: 42px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Dashboard/Sidebar.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,+BAAA;EACA,0BAAA;EACA,4EAAA;AACF;;AAGA;EACE,kBAAA;AAAF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAAJ;;AAKA;EACE,yBAAA;EACA,0CAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;AAFF;;AAKA;EACE,yBAAA;EACA,WAAA;AAFF;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kCAAA;AAHF;AAKE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAHJ;AAME;EACE,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAJJ;AAOE;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;AALJ;;AAUA;EACE,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;AAPF;;AAWA;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;AARF;;AAWA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;AARF;;AAWA;EACE,yBAAA;AARF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AAPF;;AAWE;EACE,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AARJ;;AAUE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;EACA,kCAAA;AAPJ;;AAWE;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACF,gBAAA;AARF;;AAWE;EACE,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AARJ","sourcesContent":[".custom-sidebar {\n  min-width:350px;\n  max-width: 360px;\n  min-height: 70vh;\n  background-color: #ffffff;\n  color: #000;\n  overflow: auto !important;\n  transition: width 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 10;\n  border-right: 1px solid #e4e6f1;\n  padding: 10px 6px 10px 6px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n// + Create New Test Button\n.sidebar-create {\n  margin-bottom: 0px;\n\n  .btn {\n    font-size: 14px;\n    font-weight: 500;\n    border: none;\n    background-color: #0d99ff;\n    border-radius: 12px;\n    height: 42px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 16px;\n  }\n}\n\n// Custom Dropdown Menu\n.custom-dropdown {\n  background-color: #ffffff;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n  margin-top: 5px;\n  position: absolute;\n  min-width: 300px;\n  z-index: 999;\n  border: 1px solid #e4e6f1;\n  overflow: hidden;\n}\n\n.custom-dropdown .dropdown-item {\n  padding: 10px 16px;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.custom-dropdown .dropdown-item:hover {\n  background-color: #f1f3f5;\n  color: #000;\n}\n\n// Recent + Search + Filter Bar\n.sidebar-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-top: 1px solid lightgray;\n  border-bottom: 1px solid lightgray;\n\n  h6 {\n    font-size: 15px;\n    font-weight: 600;\n    margin: 0;\n  }\n\n  .form-control {\n    background-color: #f2f4f8;\n    border: 1px solid #ccc;\n    color: #000;\n    font-size: 13px;\n    height: 30px;\n  }\n\n  .btn {\n    font-size: 13px;\n    height: 30px;\n    padding: 0 10px;\n    border: 1px solid #ccc;\n    color: #333;\n    background-color: #fff;\n  }\n}\n\n// Tab Buttons\n.sidebar-tabs .btn-group .btn {\n  font-size: 13px;\n  border-radius: 6px !important;\n  background-color: #f0f0f0;\n  color: #000;\n  border: none;\n  font-weight: 500;\n}\n\n.sidebar-tabs .btn-group .btn.active {\n  background-color: #1E1E1E;\n  color: #fff;\n  font-weight: bold;\n}\n\n// User Story List\n.sidebar-list {\n  overflow-y: auto;\n  flex-grow: 1;\n  padding-bottom: 10px;\n}\n\n.sidebar-list > div {\n  background: #fff;\n  border-radius: 8px;\n  padding: 8px 10px;\n  font-size: 13px;\n  margin-bottom: 10px;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.sidebar-list > div:hover {\n  background-color: #f0f0f5;\n}\n.search-input {\n  font-size: 17px;\n  max-width: 200px;\n  margin-left: 4px;\n  border-radius: 3px;\n  color: black;\n  border: 1px solid lightgrey;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  outline: none;\n  box-shadow: none;\n}\n\n// Draggable Resizer\n  .resizer {\n    width: 5px;\n    cursor: col-resize;\n    background-color: #f1f1f1;\n    height: 100vh;\n    position: relative;\n    z-index: 9;\n  }\n  .bordered-section {\n    margin-top: 7px;\n    margin-left: 6px;\n    margin-right: 5px;\n    margin-bottom: 10px;\n    border-top: 1px solid lightgray;\n    border-bottom: 1px solid lightgrey;\n    // border-left: 1px solid grey; // Uncomment if needed\n    // border-radius: 10px;         // Uncomment if needed\n  }\n  .createnewbtn{\n    background-color: #077fd5;\n    font-weight: 500;\n    font-size: 14px;\n    border: none;\n    border-radius: 12px;\n    height: 42px;\n    color:white;\n  min-width:300px\n\n  }\n  .createnewbtn:hover {\n    background-color: #0C8CE9;\n    font-weight: 500;\n    font-size: 14px;\n    border: none;\n    border-radius: 12px;\n    height: 42px;\n    color:white;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
